export default "__VITE_ASSET__BrcQuBwx__"